module.exports = __webpack_public_path__ + "694d18505c6b015dc95afe357dd206a2.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/company/whats-new/update/2018-05-23/whats-new.html
// module id = 1904
// module chunks = 0